import type { DataJobRunStatus } from '../types/data-jobs.types';
import {
  PortalDsBadge,
  type PortalDsBadgeVariant,
} from 'src/components/portal-design-system';

const STATUS_VARIANTS: Record<DataJobRunStatus, PortalDsBadgeVariant> = {
  pending: 'gray',
  queued: 'blue',
  running: 'blue',
  success: 'green',
  warning: 'amber',
  failed: 'red',
  cancelled: 'gray',
  interrupted: 'red',
};

const STATUS_LABELS: Record<DataJobRunStatus, string> = {
  pending: 'waiting',
  queued: 'queued',
  running: 'running',
  success: 'success',
  warning: 'warning',
  failed: 'failed',
  cancelled: 'cancelled',
  interrupted: 'interrupted',
};

interface DataJobStatusBadgeV2Props {
  status: DataJobRunStatus | string | null | undefined;
}

export function DataJobStatusBadgeV2({ status }: DataJobStatusBadgeV2Props) {
  const key = (status ?? 'pending') as DataJobRunStatus;
  const variant = STATUS_VARIANTS[key] ?? 'gray';

  return (
    <PortalDsBadge variant={variant} pill>
      {STATUS_LABELS[key] ?? key}
    </PortalDsBadge>
  );
}
